<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__section container__section_left">
        <div class="content">
          <div class="content__section content__section_products">
            <ng-container
              *ngIf="!(discountService.activeDiscountCampaignsObservable | async)"
            >
              <app-product
                class="product"
                *ngFor="let p of products"
                [id]="p.bookId"
                [title]="p.name"
                [specs]="p.specs"
                [price]="getProductPrice(p)"
                [photo]="p.image"
                (close)="removeProduct(p.bookId)"
              >
                <!-- <div class="product__select">
                  <app-select
                    [value]="p.wrapping.name"
                    (change)="selectWrapping(p, $event)"
                  >
                    <app-select-option *ngFor="let w of p.wrappings"
                      [label]="w.label"
                      [title]="w.name"
                      [photo]="w.image"
                      [price]="w.price.currency+w.price.value"
                      [value]="w.name"
                      [descr]="w.description"
                    ></app-select-option>
                  </app-select>
                </div> -->
                <div
                  class="product__radio"
                  *ngFor="let cover of p.covers"
                >
                  <app-product-radio-card
                    [active]="cover.name === p.cover.name"
                    [imgSrc]="cover.image"
                    [caption]="cover.name"
                    [summary]="cover.summary"
                    [price]="cover.price"
                    (radioCardClick)="selectCover(p, cover.name)"
                  ></app-product-radio-card>
                </div>
              </app-product>
            </ng-container>
            <ng-container
              *ngIf="(discountService.activeDiscountCampaignsObservable | async) as discountCampaign"
            >
              <app-product
                class="product"
                *ngFor="let p of products"
                [id]="p.bookId"
                [title]="p.name"
                [specs]="p.specs"
                [price]="getProductPrice(p)"
                [discount]="getBooksDiscount(discountCampaign, p.alias)"
                [photo]="p.image"
                (close)="removeProduct(p.bookId)"
              >
                <!-- <div class="product__select">
                  <app-select
                    [value]="p.wrapping.name"
                    (change)="selectWrapping(p, $event)"
                  >
                    <app-select-option *ngFor="let w of p.wrappings"
                      [label]="w.label"
                      [title]="w.name"
                      [photo]="w.image"
                      [price]="w.price.currency+w.price.value"
                      [value]="w.name"
                      [descr]="w.description"
                    ></app-select-option>
                  </app-select>
                </div> -->
                <div
                  class="product__radio"
                  *ngFor="let cover of p.covers"
                >
                  <app-product-radio-card
                    [active]="cover.name === p.cover.name"
                    [imgSrc]="cover.image"
                    [caption]="cover.name"
                    [summary]="cover.summary"
                    [price]="cover.price"
                    [discount]="getBooksDiscount(discountCampaign, p.alias)"
                    (radioCardClick)="selectCover(p, cover.name)"
                  ></app-product-radio-card>
                </div>
              </app-product>
            </ng-container>
          </div>
          <div class="content__section content__section_button">
            <app-button
              color="accent-2"
              (buttonClick)="addAnotherBookButtonClick()"
            >{{ 'Add another book' | translate }}</app-button>
          </div>
          <div class="content__section content__section_payment"
            fxHide.lt-lg
          >
            <app-payments></app-payments>
          </div>
        </div>
      </div>
      <div class="container__section container__section_right">
        <div class="sidebar">
          <div class="sidebar__calculator">
            <div class="calculator">
              <div class="calculator__component">
                <app-calculator
                  [items]="calculatorItems"
                ></app-calculator>
              </div>
              <p class="calculator__footer-text">*送料は発送方法や発送先で変わる場合があります</p>
            </div>
          </div>
          <div class="sidebar__coupon">
            <app-coupon [orderId]="orderId"></app-coupon>
          </div>
          <div class="sidebar__button">
            <div class="proceed-btn">
              <p class="proceed-btn__header-text">
                絵本の内容にお間違いはありませんか？
                <br>
                ご注文後はキャンセルできません
              </p>
              <div class="proceed-btn__component">
                <app-button
                  [disabled]="!isProceed"
                  [icons]="['arrow-right']"
                  (buttonClick)="proceed()"
                  [fullWidth]="true"
                >{{ 'Proceed to Payment' | translate }}</app-button>
              </div>
              <p
                *ngIf="isLimitExceeded"
                class="proceed-btn__footer-text"
              >一度にカートに入れられるのは4冊までです。</p>
            </div>
          </div>
          <div class="sidebar__payment"
            fxHide.gt-md
          >
            <app-payments></app-payments>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
